
      function isShopifyThemeEditor() {
        return typeof Shopify !== 'undefined' && Shopify.designMode;
      }
      
      function isMobileDevice() {
        return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      }
      
      if (isShopifyThemeEditor()) {
        sessionStorage.setItem('disableSecurity', 'true');
      }
      
      function isSecurityDisabled() {
        return sessionStorage.getItem('disableSecurity') === 'true';
      }
      
      document.addEventListener('contextmenu', event => {
        event.preventDefault();
      });
      
      const disableSelectionStyles = document.createElement('style');
      disableSelectionStyles.innerHTML = `
        * {
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -khtml-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }
      `;
      document.head.appendChild(disableSelectionStyles);
      
      document.addEventListener('dragstart', event => {
        if (event.target.tagName === 'IMG') {
          event.preventDefault();
        }
      });
      
    if (!isSecurityDisabled() && !isMobileDevice()) {
  document.addEventListener('DOMContentLoaded', function() {
    const redirectTo = 'https://www.google.com';
    const threshold = 160;

    const detectDevTools = function() {
      if (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold) {
        window.location.replace(redirectTo);
      }
    };

    window.addEventListener('resize', detectDevTools);
    detectDevTools();
  });
}

      
      document.addEventListener('keydown', function(event) {
        if (event.keyCode === 123 || (event.ctrlKey && event.shiftKey && event.keyCode === 73)) {
          event.preventDefault();
        }
      });
